export const languages = [
  {
    label: "Polski",
    code: "pl-PL",
  },
  {
    label: "English",
    code: "en-US",
  },
  {
    label: "Deutsche",
    code: "de-DE",
  },
];

export const votes = {
  "pl-PL": "głosów",
  "en-US": "votes",
  "de-DE": "Bewertungen",
};

export const popularMovies = {
  "pl-PL": "Popularne filmy",
  "en-US": "Popular movies",
  "de-DE": "Beliebte Filme",
};

export const searchingFor = {
  "pl-PL": "Wyszukiwanie wynikow dla",
  "en-US": "Searching for",
  "de-DE": "Suchen für",
};

export const searchResultsFor = {
  "pl-PL": "Wyniki wyszukiwania dla",
  "en-US": "Search results for",
  "de-DE": "Suchergebnisse für",
};

export const noResults = {
  "pl-PL": "Przepraszamy, brak wyników dla",
  "en-US": "Sorry, there are no results for",
  "de-DE": "Entschuldigung, es gibt keine Ergebnisse für",
};

export const searchFor = {
  "pl-PL": "Szukaj",
  "en-US": "Search for",
  "de-DE": "Suche nach",
};

export const movies = {
  "pl-PL": "filmów",
  "en-US": "movies",
  "de-DE": "Filme",
};

export const people = {
  "pl-PL": "osób",
  "en-US": "people",
  "de-DE": "Personen",
};

export const moviesNavigation = {
  "pl-PL": "filmy",
  "en-US": "movies",
  "de-DE": "Filme",
};

export const peopleNavigation = {
  "pl-PL": "aktorzy",
  "en-US": "people",
  "de-DE": "Personen",
};

export const popularPeople = {
  "pl-PL": "Popularni aktorzy",
  "en-US": "Popular people",
  "de-DE": "Beliebte Personen",
};

export const errorTitle = {
  "pl-PL": "Ups! Coś poszło nie tak…",
  "en-US": "Ooops! Something went wrong…",
  "de-DE": "Ups! Etwas ist schief gelaufen…",
};

export const errorText = {
  "pl-PL": "Sprawdź połączenie sieciowe i spróbuj ponownie",
  "en-US": "Please check your network connection and try again",
  "de-DE":
    "Bitte überprüfen Sie Ihre Netzwerkverbindung und versuchen Sie es erneut",
};

export const returnButton = {
  "pl-PL": "Powrót do strony głownej",
  "en-US": "Back to home page",
  "de-DE": "Zurück zur Startseite",
};

export const first = {
  "pl-PL": "Pierwsza",
  "en-US": "First",
  "de-DE": "Erste",
};

export const previous = {
  "pl-PL": "Poprzednia",
  "en-US": "Previous",
  "de-DE": "Vorherige",
};

export const page = {
  "pl-PL": "Strona",
  "en-US": "Page",
  "de-DE": "Seite",
};

export const ofPage = {
  "pl-PL": "z",
  "en-US": "of",
  "de-DE": "von",
};

export const next = {
  "pl-PL": "Następna",
  "en-US": "Next",
  "de-DE": "Nächste",
};

export const last = {
  "pl-PL": "Ostatnia",
  "en-US": "Last",
  "de-DE": "Letzte",
};

export const cast = {
  "pl-PL": "Obsada",
  "en-US": "Cast",
  "de-DE": "Besetzung",
};

export const crew = {
  "pl-PL": "Ekipa",
  "en-US": "Crew",
  "de-DE": "Filmstab",
};

export const production = {
  "pl-PL": "Produkcja",
  "en-US": "Production",
  "de-DE": "Produktion",
};

export const releaseDate = {
  "pl-PL": "Data premiery",
  "en-US": "Release date",
  "de-DE": "Veröffentlichungsdatum",
};

export const readLess = {
  "pl-PL": "Czytaj mniej",
  "en-US": "Read less",
  "de-DE": "Lese weniger",
};

export const readMore = {
  "pl-PL": "Czytaj więcej",
  "en-US": "Read more",
  "de-DE": "Weiterlesen",
};

export const dateOfBirth = {
  "pl-PL": "Data urodzenia",
  "en-US": "Date of birth",
  "de-DE": "Geburtsdatum",
};

export const birth = {
  "pl-PL": "Urodzony",
  "en-US": "Birth",
  "de-DE": "Geburt",
};

export const placeOfBirth = {
  "pl-PL": "Miejsce urodzenia",
  "en-US": "Place of birth",
  "de-DE": "Geburtsort",
};
